const readMoreContent = document.querySelectorAll(".mb-readmore");

const readMoreExpandLabel = "Mehr";
const readMoreCompressLabel = "Weniger";

const maxHeightCompressed = 659;

export function initReadmore() {
  for (let i = 0; i < readMoreContent.length; i++) {
    // Wrap content
    const innnerHTML = readMoreContent[i].innerHTML;
    const contentWrapper = document.createElement("div");
    const textReadmore = readMoreContent[i].hasAttribute("data-text-readmore")
      ? readMoreContent[i].getAttribute("data-text-readmore")
      : readMoreExpandLabel;
    const textReadless = readMoreContent[i].hasAttribute("data-text-readless")
      ? readMoreContent[i].getAttribute("data-text-readless")
      : readMoreCompressLabel;

    contentWrapper.classList.add("mb-readmore-wrapper");
    contentWrapper.innerHTML = innnerHTML;
    readMoreContent[i].innerHTML = "";
    readMoreContent[i].appendChild(contentWrapper);

    // Create label
    const readMoreLabel = document.createElement("span");
    readMoreLabel.classList.add("mb-readmore-toggle");
    readMoreLabel.innerHTML = textReadmore;
    readMoreContent[i].appendChild(readMoreLabel);

    // Add click listener
    readMoreLabel.addEventListener("click", (e) => {
      readMoreContent[i].classList.toggle("mb-readmore-expanded");

      if (readMoreContent[i].classList.contains("mb-readmore-expanded")) {
        readMoreLabel.innerHTML = textReadless;
        readMoreContent[i].style.maxHeight =
          contentWrapper.offsetHeight + 70 + "px";
      } else {
        readMoreLabel.innerHTML = textReadmore;
        readMoreContent[i].style.cssText = "";
      }
    });
  }

  updateReadMore();
}

export function updateReadMore() {
  for (let i = 0; i < readMoreContent.length; i++) {
    const contentWrapper = readMoreContent[i].querySelector(
      ".mb-readmore-wrapper"
    );

    const contentMaxHeight = readMoreContent[i].hasAttribute(
      "data-readmore-height"
    )
      ? readMoreContent[i].getAttribute("data-readmore-height")
      : maxHeightCompressed;

    // check total height
    if (contentWrapper.offsetHeight > parseInt(contentMaxHeight)) {
      readMoreContent[i].classList.add("mb-readmore-active");
    } else {
      readMoreContent[i].classList.remove("mb-readmore-active");
    }
  }
}
